import React, { useState, useEffect } from 'react'
import { compileTimestamp, eventDateInputValue, eventTimeInputValue } from "../../utils/datetime.js";
import { serverTimestamp, collection, addDoc,updateDoc,doc } from "firebase/firestore";
import { addEvent } from '../../api/EventsAPI';
import { useModal } from '../../contexts/ModalContext';
import { storage, db } from '../../firebase/config.js';
import { types } from '../../constants/eventVars.js';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { FallingLines } from "react-loader-spinner";
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';

export default function Create({ user, editMode, eventData, goBack }) {
    const { openModal } = useModal();

    const [eventType, seteventType] = useState('expert');
    const [isLoading, setisLoading] = useState(false);

    // Movement Expert State
    const [expertName, setExpertName] = useState('');
    const [primaryPhotoFile, setPrimaryPhotoFile] = useState(null);
    const [primaryPhotoPreview, setPrimaryPhotoPreview] = useState('');
    const [secondaryPhotoFile, setSecondaryPhotoFile] = useState(null);
    const [secondaryPhotoPreview, setSecondaryPhotoPreview] = useState('');
    const [coverPhotoFile, setCoverPhotoFile] = useState(null);
    const [coverPhotoPreview, setCoverPhotoPreview] = useState('');
    const [accolades, setAccolades] = useState('');
    const [tags, setTags] = useState([]);
    const [tagInput, setTagInput] = useState('');
    const [roles, setRoles] = useState([]);
    const [roleInput, setRoleInput] = useState('');
    const [hoverBio, setHoverBio] = useState('');
    const [hoverSkills, setHoverSkills] = useState([]);
    const [hoverSkillInput, setHoverSkillInput] = useState('');
    const [connectionReason, setConnectionReason] = useState('');
    const [profileBio, setProfileBio] = useState('');
    const [qualifications, setQualifications] = useState([{ title: '', institution: '', year: '' }]);
    const [specializations, setSpecializations] = useState([]);
    const [specializationInput, setSpecializationInput] = useState('');
    const [languages, setLanguages] = useState([]);
    const [languageInput, setLanguageInput] = useState('');
    const [location, setLocation] = useState('');
    const [services, setServices] = useState([{ id: crypto.randomUUID(), name: '', price: '', period: 'session', description: '' }]);

    const [title, setTitle] = useState("");
    const [infoHeader, setInfoHeader] = useState("");
    const [infoParagraph, setInfoParagraph] = useState("");
    const [infoParagraph2, setInfoParagraph2] = useState("");
    const [eventImages, setEventImages] = useState([]);
    const [date, setDate] = useState(new Date().toISOString().split('T')[0]); // Set to today's date in YYYY-MM-DD format
    const [time, setTime] = useState("");
    // const [location, setLocation] = useState("");

    const [locationName, setlocationName] = useState("");
    const [locationAddress, setlocationAddress] = useState("");
    const [latitude, setlatitude] = useState(null);
    const [longitude, setlongitude] = useState(null);

    const [tickets, setTickets] = useState([{ type: "", price: 0, numAvailable: 0, desc: "" }]);
    const [coverImage, setcoverImage] = useState('');
    const [selectedType, setselectedType] = useState(null);
    const [repeat, setrepeat] = useState(0);

    useEffect(() => {
        if (editMode) {
            initData()
        } else {
            cleanup()
        }
    }, [editMode])



    function initData() {//only meetups for now
        seteventType(eventData.connectionType || 'meetup'); //TODO
        setTitle(eventData.title || "");
        setselectedType(eventData.type || null);
        setInfoHeader(eventData.info.header || "");
        setInfoParagraph(eventData.info.paragraph || "");
        // setInfoParagraph2(eventData.info.paragraph2 || ""); Event only
        setDate(eventDateInputValue(eventData));
        setTime(eventTimeInputValue(eventData));
        setrepeat(eventData.repeat || 0);
        setlocationName(eventData.location.name);
        setlocationAddress(eventData.location.address);
        setlatitude(eventData.location.latitude);
        setlongitude(eventData.location.longitude);
        // setTickets(eventData.ticketOptions || [{ type: "", price: 0, numAvailable: 0, desc: "" }]); Event only
        setEventImages(eventData.eventImages || []);
        setcoverImage(eventData.coverImage || '');
    }

    function cleanup() {
        setTitle("");
        setInfoHeader("");
        setInfoParagraph("");
        setInfoParagraph2("");
        setEventImages([]);
        setDate(new Date().toISOString().split('T')[0]); // Set to today's date in YYYY-MM-DD format
        setTime("");
        // setLocation("");
        setlocationName("")
        setlocationAddress("")
        setlatitude(null)
        setlongitude(null)

        setTickets([{ type: "", price: 0, numAvailable: 0, desc: "" }]);
        setcoverImage('');
        setselectedType(null);
        setrepeat(0);
    }

    function cleanupExpert() {
        setExpertName('');
        setPrimaryPhotoFile(null);
        setPrimaryPhotoPreview('');
        setSecondaryPhotoFile(null);
        setSecondaryPhotoPreview('');
        setCoverPhotoFile(null);
        setCoverPhotoPreview('');
        setAccolades('');
        setTags([]);
        setTagInput('');
        setRoles([]);
        setRoleInput('');
        setHoverBio('');
        setHoverSkills([]);
        setHoverSkillInput('');
        setConnectionReason('');
        setProfileBio('');
        setQualifications([{ title: '', institution: '', year: '' }]);
        setSpecializations([]);
        setSpecializationInput('');
        setLanguages([]);
        setLanguageInput('');
        setLocation('');
        setServices([{ id: crypto.randomUUID(), name: '', price: '', period: 'session', description: '' }]);
    }

    // Chip handlers
    const addChip = (value, list, setList, setInput) => {
        if (value.trim() && !list.includes(value.trim())) {
            setList([...list, value.trim()]);
            setInput('');
        }
    };

    const removeChip = (value, list, setList) => {
        setList(list.filter(item => item !== value));
    };

    // Qualification handlers
    const handleQualificationChange = (index, field, value) => {
        const updated = [...qualifications];
        updated[index][field] = field === 'year' ? (value === '' ? '' : parseInt(value)) : value;
        setQualifications(updated);
    };

    const addQualification = () => {
        setQualifications([...qualifications, { title: '', institution: '', year: '' }]);
    };

    const removeQualification = (index) => {
        setQualifications(qualifications.filter((_, i) => i !== index));
    };

    // Service handlers
    const handleServiceChange = (index, field, value) => {
        const updated = [...services];
        updated[index][field] = field === 'price' ? (value === '' ? '' : parseFloat(value)) : value;
        setServices(updated);
    };

    const addService = () => {
        setServices([...services, { id: crypto.randomUUID(), name: '', price: '', period: 'session', description: '' }]);
    };

    const removeService = (index) => {
        setServices(services.filter((_, i) => i !== index));
    };

    // Photo file handlers
    const handlePhotoSelect = (e, setFile, setPreview) => {
        const file = e.target.files[0];
        if (file) {
            setFile(file);
            const reader = new FileReader();
            reader.onloadend = () => setPreview(reader.result);
            reader.readAsDataURL(file);
        }
    };

    const clearPhoto = (setFile, setPreview, inputId) => {
        setFile(null);
        setPreview('');
        const input = document.getElementById(inputId);
        if (input) input.value = '';
    };

    // Upload expert photo to Firebase Storage
    const uploadExpertPhoto = async (file, expertId, photoType) => {
        if (!file) return '';
        const uniqueName = `${photoType}-${Date.now()}-${file.name}`;
        const fileRef = ref(storage, `expertPhotos/${expertId}/${uniqueName}`);
        await uploadBytes(fileRef, file);
        return await getDownloadURL(fileRef);
    };

    // Expert validation
    const expertValidationPassed = () => {
        if (!expertName.trim()) {
            openModal("alert", { alertProps: { type: 0, message: "Please enter a name" } });
            return false;
        }
        if (!primaryPhotoFile) {
            openModal("alert", { alertProps: { type: 0, message: "Please select a primary photo" } });
            return false;
        }
        if (roles.length === 0) {
            openModal("alert", { alertProps: { type: 0, message: "Please add at least one role" } });
            return false;
        }
        const validServices = services.filter(s => s.name.trim() && s.price);
        if (validServices.length === 0) {
            openModal("alert", { alertProps: { type: 0, message: "Please add at least one complete service" } });
            return false;
        }
        return true;
    };

    // Create Movement Expert
    async function createExpertSubmit() {
        if (!expertValidationPassed()) return;

        setisLoading(true);
        try {
            // First create the document to get an ID
            const tempData = {
                name: expertName.trim(),
                createdAt: serverTimestamp()
            };
            const docRef = await addDoc(collection(db, 'users_trainer'), tempData);
            const expertId = docRef.id;

            // Upload photos
            const [primaryPhotoUrl, secondaryPhotoUrl, coverPhotoUrl] = await Promise.all([
                uploadExpertPhoto(primaryPhotoFile, expertId, 'primary'),
                uploadExpertPhoto(secondaryPhotoFile, expertId, 'secondary'),
                uploadExpertPhoto(coverPhotoFile, expertId, 'cover')
            ]);

            const expertData = {
                id: expertId,
                name: expertName.trim(),
                primaryPhoto: primaryPhotoUrl,
                secondaryPhoto: secondaryPhotoUrl,
                coverPhoto: coverPhotoUrl,
                accolades: accolades.trim(),
                tags,
                roles,
                hoverInfo: {
                    bio: hoverBio.trim(),
                    skills: hoverSkills,
                    connectionReason: connectionReason.trim()
                },
                profile: {
                    bio: profileBio.trim(),
                    qualifications: qualifications.filter(q => q.title.trim()),
                    specializations,
                    languages,
                    location: location.trim()
                },
                services: services.filter(s => s.name.trim() && s.price).map(s => ({
                    ...s,
                    price: parseFloat(s.price) || 0
                })),
                createdAt: serverTimestamp()
            };
            // Update the document with full data
            await updateDoc(doc(db, 'users_trainer', expertId), expertData);

            openModal("alert", { alertProps: { type: 2, message: "Movement Expert created successfully!" } });
            cleanupExpert();
        } catch (error) {
            console.error('Error creating expert:', error);
            openModal("alert", { alertProps: { type: 0, message: "Error creating expert. Please try again." } });
        }
        setisLoading(false);
    }

    const isExpertFormValid = expertName.trim() && primaryPhotoFile && roles.length > 0 && services.some(s => s.name.trim() && s.price);

    async function createEventSubmitClicked(type) {
        setisLoading(true)
        let eventProps = {
            title: title,
            type: selectedType,
            timestamp: compileTimestamp(date, time),     // format: 'YYYY-MM-DD'
            location: {
                name: locationName,
                address: locationAddress,
                latitude,
                longitude
            },
            coverImage: coverImage,
            host: {
                name: user.displayName,
                id: user.uid,
                photoURL: user.photoURL,
                // createdAt: user.createdAt
            },
            isLive: false,
            tags: [],
            createdAt: serverTimestamp()
        }
        if (eventType === 'meetup') {
            if (!meetupValidationPassed()) {
                setisLoading(false)
                return
            }
            eventProps = {
                ...eventProps,
                connectionType: 'meetup',
                info: { header: infoHeader, paragraph: infoParagraph },
                repeat: repeat,
            }
        } else if (eventType === 'event') {
            eventProps = {
                ...eventProps,
                connectionType: 'event',
                info: { header: infoHeader, paragraph: infoParagraph, paragraph2: infoParagraph2 },
                ticketOptions: tickets, // Array of ticket objects
                numReserved: 0
            }
        }

        const responseId = await addEvent(eventProps)
        if (responseId) {
            console.log("Document written, uploading images...");
            openModal("alert", {
                alertProps: { type: 2, message: "Document written" },
            });
            if (eventImages !== null) {
                await uploadEventImages(eventImages, responseId) //only upload pic if event created successfully
            }
        } else {
            openModal("alert", {
                alertProps: { type: 0, message: "Error" },
            });
        }
        setisLoading(false)
    }
    const meetupValidationPassed = () => {
        if (title === "") {
            openModal("alert", {
                alertProps: { type: 0, message: "Please enter a title" },
            });
            return false;
        }
        if (selectedType === null) {
            openModal("alert", {
                alertProps: { type: 0, message: "Please select a type" },
            });
            return false;
        }
        if (infoHeader === "") {
            openModal("alert", {
                alertProps: { type: 0, message: "Please enter an info header" },
            });
            return false;
        }
        if (infoParagraph === "") {
            openModal("alert", {
                alertProps: { type: 0, message: "Please enter an info paragraph" },
            });
            return false;
        }
        if (date === "") {
            openModal("alert", {
                alertProps: { type: 0, message: "Please select a date" },
            });
            return false;
        }
        if (time === "") {
            openModal("alert", {
                alertProps: { type: 0, message: "Please select a time" },
            });
            return false;
        }
        if (locationName === "") {
            openModal("alert", {
                alertProps: { type: 0, message: "Please enter a location name" },
            });
            return false;
        }
        if (locationAddress === "") {
            openModal("alert", {
                alertProps: { type: 0, message: "Please enter a location address" },
            });
            return false;
        }
        if (coverImage === "") {
            openModal("alert", {
                alertProps: { type: 0, message: "Please select a cover image" },
            });
            return false;
        }
        return true
    }
    async function uploadEventImages(files, eventId) {
        const uploadPromises = files.map(async (file) => {
            // const uniqueName = `${uuidv4()}-${file.name}`;
            const uniqueName = `${file.name}`;
            const fileRef = ref(storage, `eventPictures/${eventId}/${uniqueName}`);
            await uploadBytes(fileRef, file);
            const url = await getDownloadURL(fileRef);
            return url;
        });
        try {
            const downloadURLs = await Promise.all(uploadPromises);
            return downloadURLs;
        } catch (error) {
            console.error('Error uploading images:', error);
            throw error;
        }
    }
    const getRepeatIndicationText = () => {
        if (repeat === 'Weekly') {
            return "This event will repeat weekly."
        } else if (repeat === 'Monthly') {
            return "This event will repeat monthly."
        } else {
            return "This event will only happen once."
        }
    }

    const handleSelect = (activity) => {
        setselectedType(activity);
    };

    const handleImageUpload = (e) => {
        setEventImages([...eventImages, ...Array.from(e.target.files)]);
    };

    const handleTicketChange = (index, key, value) => {
        const newTickets = [...tickets];
        newTickets[index][key] = value;
        setTickets(newTickets);
    };

    const addTicketOption = () => {
        setTickets([...tickets, { type: "", price: 0, numAvailable: 0, desc: "" }]);
    };


    return (
        <div className='create-page'>

            <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '9px' }}>
                <h1>{editMode ? "Edit " + eventData.id : "Create New"}</h1>
                {editMode && <button className="back-button" onClick={() => goBack()} style={{}}><CloseIcon /></button>}
            </div>
            {!editMode &&
                <div style={{ display: 'flex', flexDirection: 'row', gap: '9px', marginBottom: '0px' }}>
                    <button className={eventType === 'expert' ? 'event-type-button selected' : 'event-type-button'} onClick={() => seteventType('expert')}>Movement Expert</button>
                    <button className={eventType === 'event' ? 'event-type-button selected' : 'event-type-button'} onClick={() => seteventType('event')}>Event</button>
                    <button className={eventType === 'meetup' ? 'event-type-button selected' : 'event-type-button'} onClick={() => seteventType('meetup')}>Meet</button>
                </div>
            }
            {eventType === 'expert' ?
                <div style={{ flex: 1 }}>
                    <div className="create-body-container">
                        <div className="dashboard-card" style={{ flexDirection: 'column', gap: '24px' }}>
                            {/* Basic Info Section */}
                            <div className="expert-section">
                                <h3 className="section-title">Basic Information</h3>
                                <div className="section-divider"></div>
                                <div className="expert-form-grid">
                                    <div className="form-field">
                                        <label>Name *</label>
                                        <input className="event-input full-width" value={expertName} onChange={(e) => setExpertName(e.target.value)} placeholder="Expert's full name" />
                                    </div>
                                    <div className="form-field">
                                        <label>Accolades</label>
                                        <input className="event-input full-width" value={accolades} onChange={(e) => setAccolades(e.target.value)} placeholder="e.g. PhD, CSCS, 10+ Years Experience" />
                                    </div>
                                    <div className="form-field">
                                        <label>Location</label>
                                        <input className="event-input full-width" value={location} onChange={(e) => setLocation(e.target.value)} placeholder="e.g. Sydney, Australia" />
                                    </div>
                                </div>
                            </div>

                            {/* Photos Section */}
                            <div className="expert-section">
                                <h3 className="section-title">Photos</h3>
                                <div className="section-divider"></div>
                                <div className="expert-form-grid">
                                    <div className="form-field">
                                        <label>Primary Photo *</label>
                                        <div className="photo-upload-container">
                                            <input
                                                type="file"
                                                id="primaryPhotoInput"
                                                accept="image/*"
                                                onChange={(e) => handlePhotoSelect(e, setPrimaryPhotoFile, setPrimaryPhotoPreview)}
                                                className="photo-file-input"
                                            />
                                            <label htmlFor="primaryPhotoInput" className="photo-upload-btn">
                                                {primaryPhotoFile ? 'Change Photo' : 'Select Photo'}
                                            </label>
                                            {primaryPhotoFile && (
                                                <button type="button" className="photo-clear-btn" onClick={() => clearPhoto(setPrimaryPhotoFile, setPrimaryPhotoPreview, 'primaryPhotoInput')}>
                                                    <CloseIcon fontSize="small" />
                                                </button>
                                            )}
                                        </div>
                                        {primaryPhotoPreview && <img src={primaryPhotoPreview} alt="Primary preview" className="photo-preview" />}
                                    </div>
                                    <div className="form-field">
                                        <label>Secondary Photo</label>
                                        <div className="photo-upload-container">
                                            <input
                                                type="file"
                                                id="secondaryPhotoInput"
                                                accept="image/*"
                                                onChange={(e) => handlePhotoSelect(e, setSecondaryPhotoFile, setSecondaryPhotoPreview)}
                                                className="photo-file-input"
                                            />
                                            <label htmlFor="secondaryPhotoInput" className="photo-upload-btn">
                                                {secondaryPhotoFile ? 'Change Photo' : 'Select Photo'}
                                            </label>
                                            {secondaryPhotoFile && (
                                                <button type="button" className="photo-clear-btn" onClick={() => clearPhoto(setSecondaryPhotoFile, setSecondaryPhotoPreview, 'secondaryPhotoInput')}>
                                                    <CloseIcon fontSize="small" />
                                                </button>
                                            )}
                                        </div>
                                        {secondaryPhotoPreview && <img src={secondaryPhotoPreview} alt="Secondary preview" className="photo-preview" />}
                                    </div>
                                    <div className="form-field">
                                        <label>Cover Photo</label>
                                        <div className="photo-upload-container">
                                            <input
                                                type="file"
                                                id="coverPhotoInput"
                                                accept="image/*"
                                                onChange={(e) => handlePhotoSelect(e, setCoverPhotoFile, setCoverPhotoPreview)}
                                                className="photo-file-input"
                                            />
                                            <label htmlFor="coverPhotoInput" className="photo-upload-btn">
                                                {coverPhotoFile ? 'Change Photo' : 'Select Photo'}
                                            </label>
                                            {coverPhotoFile && (
                                                <button type="button" className="photo-clear-btn" onClick={() => clearPhoto(setCoverPhotoFile, setCoverPhotoPreview, 'coverPhotoInput')}>
                                                    <CloseIcon fontSize="small" />
                                                </button>
                                            )}
                                        </div>
                                        {coverPhotoPreview && <img src={coverPhotoPreview} alt="Cover preview" className="photo-preview cover" />}
                                    </div>
                                </div>
                            </div>

                            {/* Tags & Roles Section */}
                            <div className="expert-section">
                                <h3 className="section-title">Tags & Roles</h3>
                                <div className="section-divider"></div>
                                <div className="expert-form-grid">
                                    <div className="form-field">
                                        <label>Tags</label>
                                        <div className="chip-input-container">
                                            <input className="event-input chip-input" value={tagInput} onChange={(e) => setTagInput(e.target.value)}
                                                onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), addChip(tagInput, tags, setTags, setTagInput))}
                                                placeholder="Add tag and press Enter" />
                                            <button type="button" className="chip-add-btn" onClick={() => addChip(tagInput, tags, setTags, setTagInput)}><AddIcon fontSize="small" /></button>
                                        </div>
                                        <div className="chips-container">
                                            {tags.map((tag, i) => (
                                                <span key={i} className="chip">{tag}<CloseIcon fontSize="small" onClick={() => removeChip(tag, tags, setTags)} /></span>
                                            ))}
                                        </div>
                                    </div>
                                    <div className="form-field">
                                        <label>Roles * (at least 1)</label>
                                        <div className="chip-input-container">
                                            <input className="event-input chip-input" value={roleInput} onChange={(e) => setRoleInput(e.target.value)}
                                                onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), addChip(roleInput, roles, setRoles, setRoleInput))}
                                                placeholder="Add role and press Enter" />
                                            <button type="button" className="chip-add-btn" onClick={() => addChip(roleInput, roles, setRoles, setRoleInput)}><AddIcon fontSize="small" /></button>
                                        </div>
                                        <div className="chips-container">
                                            {roles.map((role, i) => (
                                                <span key={i} className="chip">{role}<CloseIcon fontSize="small" onClick={() => removeChip(role, roles, setRoles)} /></span>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Hover Info Section */}
                            <div className="expert-section">
                                <h3 className="section-title">Hover Info (Card Preview)</h3>
                                <div className="section-divider"></div>
                                <div className="expert-form-grid">
                                    <div className="form-field full-span">
                                        <label>Short Bio</label>
                                        <textarea className="event-input full-width" rows={3} value={hoverBio} onChange={(e) => setHoverBio(e.target.value)} placeholder="Brief bio shown on card hover" />
                                    </div>
                                    <div className="form-field">
                                        <label>Skills</label>
                                        <div className="chip-input-container">
                                            <input className="event-input chip-input" value={hoverSkillInput} onChange={(e) => setHoverSkillInput(e.target.value)}
                                                onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), addChip(hoverSkillInput, hoverSkills, setHoverSkills, setHoverSkillInput))}
                                                placeholder="Add skill and press Enter" />
                                            <button type="button" className="chip-add-btn" onClick={() => addChip(hoverSkillInput, hoverSkills, setHoverSkills, setHoverSkillInput)}><AddIcon fontSize="small" /></button>
                                        </div>
                                        <div className="chips-container">
                                            {hoverSkills.map((skill, i) => (
                                                <span key={i} className="chip">{skill}<CloseIcon fontSize="small" onClick={() => removeChip(skill, hoverSkills, setHoverSkills)} /></span>
                                            ))}
                                        </div>
                                    </div>
                                    <div className="form-field">
                                        <label>Connection Reason</label>
                                        <input className="event-input full-width" value={connectionReason} onChange={(e) => setConnectionReason(e.target.value)} placeholder="Why connect with this expert?" />
                                    </div>
                                </div>
                            </div>

                            {/* Profile Section */}
                            <div className="expert-section">
                                <h3 className="section-title">Profile Details</h3>
                                <div className="section-divider"></div>
                                <div className="expert-form-grid">
                                    <div className="form-field full-span">
                                        <label>Full Bio</label>
                                        <textarea className="event-input full-width" rows={5} value={profileBio} onChange={(e) => setProfileBio(e.target.value)} placeholder="Detailed profile bio" />
                                    </div>
                                    <div className="form-field">
                                        <label>Specializations</label>
                                        <div className="chip-input-container">
                                            <input className="event-input chip-input" value={specializationInput} onChange={(e) => setSpecializationInput(e.target.value)}
                                                onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), addChip(specializationInput, specializations, setSpecializations, setSpecializationInput))}
                                                placeholder="Add specialization" />
                                            <button type="button" className="chip-add-btn" onClick={() => addChip(specializationInput, specializations, setSpecializations, setSpecializationInput)}><AddIcon fontSize="small" /></button>
                                        </div>
                                        <div className="chips-container">
                                            {specializations.map((spec, i) => (
                                                <span key={i} className="chip">{spec}<CloseIcon fontSize="small" onClick={() => removeChip(spec, specializations, setSpecializations)} /></span>
                                            ))}
                                        </div>
                                    </div>
                                    <div className="form-field">
                                        <label>Languages</label>
                                        <div className="chip-input-container">
                                            <input className="event-input chip-input" value={languageInput} onChange={(e) => setLanguageInput(e.target.value)}
                                                onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), addChip(languageInput, languages, setLanguages, setLanguageInput))}
                                                placeholder="Add language" />
                                            <button type="button" className="chip-add-btn" onClick={() => addChip(languageInput, languages, setLanguages, setLanguageInput)}><AddIcon fontSize="small" /></button>
                                        </div>
                                        <div className="chips-container">
                                            {languages.map((lang, i) => (
                                                <span key={i} className="chip">{lang}<CloseIcon fontSize="small" onClick={() => removeChip(lang, languages, setLanguages)} /></span>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Qualifications Section */}
                            <div className="expert-section">
                                <h3 className="section-title">Qualifications</h3>
                                <div className="section-divider"></div>
                                {qualifications.map((qual, i) => (
                                    <div key={i} className="dynamic-row">
                                        <input className="event-input" value={qual.title} onChange={(e) => handleQualificationChange(i, 'title', e.target.value)} placeholder="Title/Degree" />
                                        <input className="event-input" value={qual.institution} onChange={(e) => handleQualificationChange(i, 'institution', e.target.value)} placeholder="Institution" />
                                        <input className="event-input" type="number" value={qual.year} onChange={(e) => handleQualificationChange(i, 'year', e.target.value)} placeholder="Year" style={{ width: '100px' }} />
                                        <CloseIcon onClick={() => removeQualification(i)} sx={{ color: '#c0392b', cursor: 'pointer', visibility: qualifications.length > 1 ? 'visible' : 'hidden' }} />
                                    </div>
                                ))}
                                <button type="button" className="add-row-btn" onClick={addQualification}><AddIcon fontSize="small" /> Add Qualification</button>
                            </div>

                            {/* Services Section */}
                            <div className="expert-section">
                                <h3 className="section-title">Services * (at least 1)</h3>
                                <div className="section-divider"></div>
                                {services.map((service, i) => (
                                    <div key={service.id} className="service-card">
                                        <div className="service-row">
                                            <input className="event-input" value={service.name} onChange={(e) => handleServiceChange(i, 'name', e.target.value)} placeholder="Service Name" />
                                            <input className="event-input" type="number" value={service.price} onChange={(e) => handleServiceChange(i, 'price', e.target.value)} placeholder="Price" style={{ width: '120px' }} />
                                            <select className="event-input period-select" value={service.period} onChange={(e) => handleServiceChange(i, 'period', e.target.value)}>
                                                <option value="session">per session</option>
                                                <option value="month">per month</option>
                                            </select>
                                            <CloseIcon onClick={() => removeService(i)} sx={{ color: '#c0392b', cursor: 'pointer', visibility: services.length > 1 ? 'visible' : 'hidden' }} />
                                        </div>
                                        <textarea className="event-input full-width" rows={2} value={service.description} onChange={(e) => handleServiceChange(i, 'description', e.target.value)} placeholder="Service description" />
                                    </div>
                                ))}
                                <button type="button" className="add-row-btn" onClick={addService}><AddIcon fontSize="small" /> Add Service</button>
                            </div>
                        </div>

                        <div className="button-container" style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "20px" }}>
                            <button className="create-new-button" onClick={createExpertSubmit} disabled={!isExpertFormValid || isLoading} style={{ opacity: isExpertFormValid ? 1 : 0.5 }}>
                                {isLoading ? <FallingLines color="#ffffff" width="60" visible={true} ariaLabel="falling-circles-loading" /> : 'Create Movement Expert'}
                            </button>
                        </div>
                    </div>
                </div> :
                eventType === 'meetup' ?
                    <div style={{ flex: 1 }}>
                        <div className="create-body-container" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
                            <div className="dashboard-card">
                                <div className="dashboard-card-content-left">
                                    <div>
                                        <h4>Meetup Title</h4>
                                        <input className="event-input" value={title} onChange={(e) => setTitle(e.target.value)} />
                                    </div>
                                    <div>
                                        <h4>Type</h4>
                                        <div className="activity-selector">
                                            {[...types].map((activity) => (
                                                <button
                                                    key={activity}
                                                    className={`activity-button ${selectedType === activity ? 'selected' : ''}`}
                                                    onClick={() => handleSelect(activity)}
                                                >
                                                    {activity}
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                    <div>
                                        <h4>Info Header</h4>
                                        <input className="event-input" value={infoHeader} onChange={(e) => setInfoHeader(e.target.value)} />
                                    </div>
                                    <div>
                                        <h4>Info Paragraph</h4>
                                        <textarea className="event-input" rows={4} value={infoParagraph} onChange={(e) => setInfoParagraph(e.target.value)} />
                                    </div>
                                    <div>
                                        <h4>Date</h4>
                                        <input className="event-input" type="date" value={date} onChange={(e) => setDate(e.target.value)} />
                                    </div>
                                    <div>
                                        <h4>Time</h4>
                                        <input className="event-input" type="time" value={time} onChange={(e) => setTime(e.target.value)} />
                                    </div>
                                    <div>
                                        <h4>Repeat</h4>
                                        <div className="activity-selector">
                                            {['Once off', 'Weekly', 'Monthly'].map((repeatType) => (
                                                <button
                                                    key={repeatType}
                                                    className={`activity-button ${repeat === repeatType ? 'selected' : ''}`}
                                                    onClick={() => setrepeat(repeatType)}
                                                >
                                                    {repeatType}
                                                </button>
                                            ))}
                                        </div>
                                        <p style={{ fontSize: '12px', color: 'gray' }}> {getRepeatIndicationText()}</p>
                                    </div>
                                    <div>
                                        <h4>Location</h4>
                                        <input className="event-input" placeholder="Location Name" value={locationName} onChange={(e) => setlocationName(e.target.value)} />
                                        <input className="event-input" placeholder="Location Address" value={locationAddress} onChange={(e) => setlocationAddress(e.target.value)} />
                                        <input className="event-input" type="number" placeholder="latitude" value={latitude} onChange={(e) => setlatitude(parseFloat(e.target.value))} />
                                        <input className="event-input" type="number" placeholder="longitude" value={longitude} onChange={(e) => setlongitude(parseFloat(e.target.value))} />
                                    </div>
                                </div>
                                <div className="dashboard-card-content-right">
                                    <div>
                                        <h4>Meetup Images + Cover Image (click selected)</h4>
                                        <input type="file" multiple onChange={handleImageUpload} />
                                        <div className="grid grid-cols-3 gap-2 mt-2">
                                            {eventImages.map((file, i) => (
                                                <img onClick={() => setcoverImage(file.name)} style={{ border: file.name === coverImage ? '2px solid #ff000099' : 'none' }}
                                                    className='event-image' key={i} src={URL.createObjectURL(file)} alt="preview" />
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="button-container" style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "20px" }}>
                                <button className="create-new-button" onClick={() => createEventSubmitClicked()} >
                                    {isLoading ? <FallingLines
                                        color="#ffffff"
                                        width="60"
                                        visible={true}
                                        ariaLabel="falling-circles-loading"
                                    /> : 'Create Meetup'}
                                </button>
                            </div>
                        </div>
                    </div> :
                    <div style={{ flex: 1 }}>
                        <div className="create-body-container" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
                            <div className="dashboard-card">
                                <div className="dashboard-card-content-left">
                                    <div>
                                        <h4>Event Title</h4>
                                        <input className="event-input" value={title} onChange={(e) => setTitle(e.target.value)} />
                                    </div>
                                    <div>
                                        <h4>Event Type</h4>
                                        <div className="activity-selector">
                                            {[...types].map((activity) => (
                                                <button
                                                    key={activity}
                                                    className={`activity-button ${selectedType === activity ? 'selected' : ''}`}
                                                    onClick={() => handleSelect(activity)}
                                                >
                                                    {activity}
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                    <div>
                                        <h4>Info Header</h4>
                                        <input className="event-input" value={infoHeader} onChange={(e) => setInfoHeader(e.target.value)} />
                                    </div>
                                    <div>
                                        <h4>Info Paragraph</h4>
                                        <textarea className="event-input" rows={4} value={infoParagraph} onChange={(e) => setInfoParagraph(e.target.value)} />
                                    </div>
                                    <div>
                                        <h4>{"Info Paragraph 2 (optional)"}</h4>
                                        <textarea className="event-input" rows={4} value={infoParagraph2} onChange={(e) => setInfoParagraph2(e.target.value)} />
                                    </div>
                                    <div>
                                        <h4>Date</h4>
                                        <input className="event-input" type="date" value={date} onChange={(e) => setDate(e.target.value)} />
                                    </div>
                                    <div>
                                        <h4>Time</h4>
                                        <input className="event-input" type="time" value={time} onChange={(e) => setTime(e.target.value)} />
                                    </div>
                                    <div>
                                        <h4>Location</h4>
                                        <input className="event-input" placeholder="Location Name" value={locationName} onChange={(e) => setlocationName(e.target.value)} />
                                        <input className="event-input" placeholder="Location Address" value={locationAddress} onChange={(e) => setlocationAddress(e.target.value)} />
                                        <input className="event-input" type="number" placeholder="latitude" value={latitude} onChange={(e) => setlatitude(parseFloat(e.target.value))} />
                                        <input className="event-input" type="number" placeholder="longitude" value={longitude} onChange={(e) => setlongitude(parseFloat(e.target.value))} />
                                    </div>
                                </div>
                                <div className="dashboard-card-content-right">
                                    <div className="space-y-2">
                                        <h4>Ticket Options</h4>
                                        <div className="ticket-option-row" style={{ borderBottom: '1px solid #ccc', paddingBottom: '10px' }}>
                                            <h5 style={{ flex: 1 }}>Type</h5>
                                            <h5 style={{ flex: 1 }}>Num Available</h5>
                                            <h5 style={{ flex: 1 }}>Desc</h5>
                                            <h5 style={{ flex: 1 }}>Price (R)</h5>
                                            <CloseIcon sx={{ color: 'transparent' }} />
                                        </div>
                                        {tickets.map((ticket, i) => (
                                            <div key={i} className="ticket-option-row">
                                                <input className="event-input" placeholder="Ticket Type" value={ticket.type} onChange={(e) => handleTicketChange(i, "type", e.target.value)} />
                                                <input className="event-input" type="number" placeholder="Num available" value={ticket.numAvailable} onChange={(e) => handleTicketChange(i, "numAvailable", parseInt(e.target.value))} />
                                                <input className="event-input" placeholder="Desc" value={ticket.desc} onChange={(e) => handleTicketChange(i, "desc", e.target.value)} />
                                                <input className="event-input" type="number" placeholder="Price" value={ticket.price} onChange={(e) => handleTicketChange(i, "price", parseInt(e.target.value))} />
                                                <CloseIcon onClick={() => setTickets(tickets.filter((_, index) => index !== i))} sx={{ color: 'red', cursor: 'pointer' }} />
                                            </div>
                                        ))}
                                        <button variant="outline" onClick={addTicketOption} className="w-full mt-2">
                                            + Add Ticket Option
                                        </button>
                                    </div>
                                    <div>
                                        <h4>Event Images + Cover Image (click selected)</h4>
                                        <input type="file" multiple onChange={handleImageUpload} />
                                        <div className="grid grid-cols-3 gap-2 mt-2">
                                            {eventImages.map((file, i) => (
                                                <img onClick={() => setcoverImage(file.name)} style={{ border: file.name === coverImage ? '2px solid #ff000099' : 'none' }}
                                                    className='event-image' key={i} src={URL.createObjectURL(file)} alt="preview" />
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="button-container" style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "20px" }}>
                                <button className="create-new-button" onClick={() => createEventSubmitClicked()} >
                                    {isLoading ? <FallingLines
                                        color="#ffffff"
                                        width="60"
                                        visible={true}
                                        ariaLabel="falling-circles-loading"
                                    /> : 'Create Event'}
                                </button>
                            </div>
                        </div>
                    </div>
            }
        </div>
    )
}